<template>
  <div style="background-color: #f5f5f5; height: 100%">
    <div class="essay">
      <div>
        <van-swipe :autoplay="3000" @change="onChange" style="height: 292px">
          <van-swipe-item
            v-for="item in ImgsList"
            :key="item + 'aa'"
            @click="showImagePreview(index)"
          >
            <img :src="item" style="width: 100%" />
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">
              {{ count + 1 }}/{{ ImgsList.length }}
            </div>
          </template>
        </van-swipe>
        <!-- 预览轮播图 -->
        <van-image-preview
          v-model="ImagePreviewShow"
          :images="ImgsList"
          :start-position="this.current"
          @change="onChangeImagePreview"
          @close="closeImagePreview"
        >
        </van-image-preview>
        <div class="middle">
          <div class="title van-multi-ellipsis--l2" style="margin-bottom: 18px">
            {{ storeInfo.name }}
          </div>
          <div
            class="title"
            style="color: #999999; font-size: 14px; font-weight: normal"
            @click="callphone(storeInfo.telephone)"
          >
            电话：<span
              class="title"
              style="font-size: 14px; font-weight: normal"
            >
              {{ storeInfo.telephone }}</span
            >
            <img
              src="https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1702450344768.png"
              alt=""
              style="width: 18px; vertical-align: middle; float: right"
            />
          </div>

          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: 10px;
            "
          >
            <div class="right" @click="gotominiProgram(storeInfo)">
              <div class="van-ellipsis" style="width: 88%">
                {{ storeInfo.address }}
              </div>
              <img
                style="
                  width: 11.5px;
                  position: absolute;
                  top: 50%;
                  transform: translateY(-50%);
                  right: 15px;
                "
                src="https://chiness-clothing.oss-cn-beijing.aliyuncs.com/goodsImg/042a.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div
          class="middle"
          style="width: 100%; border-radius: 0; margin-top: 12px"
        >
          <!-- 排序 -->
          <div
            style="
              display: flex;
              justify-content: space-around;
              align-items: center;
            "
          >
            <div @click="sortSale" style="display: flex; align-items: center">
              <span>销量优先</span>
              <span :class="bottom ? 'sanjiao1' : 'sanjiao'"></span>
            </div>
            <div @click="sortNew" style="display: flex; align-items: center">
              <span>最新上架</span>
              <span :class="bottom1 ? 'sanjiao1' : 'sanjiao'"></span>
            </div>
            <div @click="sortCheap" style="display: flex; align-items: center">
              <span>价格最低</span>
              <span :class="bottom2 ? 'sanjiao1' : 'sanjiao'"></span>
            </div>
          </div>

          <!-- 商品列表 -->
          <div class="list">
            <van-list
              class="vanList"
              v-model="loading"
              offset="10"
              :finished="finished"
              finished-text="没有更多了 ~"
              @load="onLoad"
              :immediate-check="false"
            >
              <div class="Box">
                <div
                  @click="
                    gotoUrl('/hotels/hotelsXq/' + item.id + '/' + integral)
                  "
                  class="li"
                  v-for="item in goodLists2"
                  :key="item.id"
                >
                  <img
                    alt=""
                    v-if="item.goodsImg != null && item.goodsImg != ''"
                    :src="item.goodsImg.split(',')[0]"
                  />
                  <img
                    v-else
                    src="http://alycommunity.anluoyun.cn/lc-lcx/2023/6/35e14c95-10b.png"
                  />
                  <div style="box-sizing: border-box; padding: 2px 7.5px 12px">
                    <div class="tit van-multi-ellipsis--l2">
                      {{ item.goodsName }}
                    </div>
                    <div class="line"></div>
                    <div class="price">
                      <img
                        src="https://chiness-clothing.oss-cn-beijing.aliyuncs.com/goodsImg/da7a.png"
                        alt=""
                        style="
                          width: 12px;
                          border-radius: 0;
                          margin-right: 4px;
                          vertical-align: middle;
                        "
                      />
                      <span style="vertical-align: middle">
                        {{ item.integral }}
                      </span>
                      <button class="duihuan">兑换</button>
                    </div>
                  </div>
                </div>
                <div
                  @click="
                    gotoUrl('/hotels/hotelsXq/' + item.id + '/' + integral)
                  "
                  class="li"
                  v-for="item in goodLists1"
                  :key="item.id"
                >
                  <img
                    alt=""
                    v-if="item.goodsImg != null && item.goodsImg != ''"
                    :src="item.goodsImg.split(',')[0]"
                  />
                  <img
                    v-else
                    src="http://alycommunity.anluoyun.cn/lc-lcx/2023/6/35e14c95-10b.png"
                  />
                  <div style="box-sizing: border-box; padding: 2px 7.5px 12px">
                    <div class="tit van-multi-ellipsis--l2">
                      {{ item.goodsName }}
                    </div>
                    <div class="line"></div>
                    <div class="price">
                      <img
                        src="https://chiness-clothing.oss-cn-beijing.aliyuncs.com/goodsImg/da7a.png"
                        alt=""
                        style="
                          width: 12px;
                          border-radius: 0;
                          margin-right: 4px;
                          vertical-align: middle;
                        "
                      />
                      <span style="vertical-align: middle">
                        {{ item.integral }}
                      </span>
                      <button class="duihuan">兑换</button>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import config from "@/config";
import Vue from "vue";
import { Toast } from "vant";
import { Dialog } from "vant";
import { getUrl, getPlatform, getIntegral } from "@/utils/auth";
import { listByStoreId } from "@/api/Hotel";
Vue.use(Toast);
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      count: "",
      ImgsList: [],
      ImagePreviewShow: false,
      index: 0,
      current: 0,
      url: config.hostUrl,
      storeInfo: {},
      bottom: false,
      bottom1: false,
      bottom2: false,
      goodLists1: [],
      goodLists2: [],
      list: [],
      integral: "", // 积分
      listfrom: {
        platformId: getPlatform(),
        pageNum: 1,
        pageSize: 10,
        storeId: this.$route.params.storeId,
        type: 0,
      }, //查询传参
    };
  },
  created() {
    this.getStoreInfo(this.$route.params.storeId);
    this.getList();
    this.integral = getIntegral();
  },
  methods: {
    // 获取分页列表
    getList() {
      listByStoreId(this.listfrom).then((res) => {
        if (res.data.code == 200) {
          // this.list = res.data.data.list;
          // this.finished = true;
          /**第二种 */
          let rows = res.data.data.list; //请求返回当页的列表
          // 加载状态结束
          console.log(rows, "rows");
          this.list = this.list.concat(rows);
          this.loading = false;

          if (!res.data.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log("结束");
            this.finished = true;
          } else {
            this.finished = false;
          }
          // if (this.list.length >= res.data.data.total) {
          //   console.log(111);
          //   this.finished = true;
          // }
        } else {
          this.finished = true;
        }
        console.log(this.list, "this.list");
        var jiArr = [];
        var ouArr = [];
        for (var i = 0; i < this.list.length; i++) {
          if (i % 2 == 0) {
            ouArr.push(this.list[i]);
          } else {
            jiArr.push(this.list[i]);
          }
        }
        console.log(jiArr, "奇数项");
        console.log(ouArr, "偶数项");
        this.goodLists1 = jiArr;
        this.goodLists2 = ouArr;
        // }
      });
    },
    callphone(phonenumber) {
      window.location.href = "tel://" + phonenumber;
    },
    // 下拉刷新
    onLoad() {
      console.log("到底啦");
      // this.list = [];
      this.listfrom.pageNum = this.listfrom.pageNum + 1;
      this.getList(undefined);
    },
    // 销量优先 排序
    sortSale() {
      this.list = [];
      this.bottom = !this.bottom;
      this.bottom1 = false;
      this.bottom2 = false;
      if (this.bottom) {
        this.listfrom.type = 1;
      } else {
        this.listfrom.type = 0;
      }
      this.getList();
    },
    // 最新上架 排序
    sortNew() {
      this.list = [];
      this.bottom1 = !this.bottom1;
      this.bottom = false;
      this.bottom2 = false;
      if (this.bottom1) {
        this.listfrom.type = 2;
      } else {
        this.listfrom.type = 0;
      }
      this.getList();
    },
    // 价格最低 排序
    sortCheap() {
      this.list = [];
      this.bottom2 = !this.bottom2;
      this.bottom = false;
      this.bottom1 = false;
      if (this.bottom2) {
        this.listfrom.type = 3;
      } else {
        this.listfrom.type = 0;
      }
      this.getList();
    },
    // 获取店铺信息
    getStoreInfo(id) {
      var that = this;
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/storeInfo";
      const params = { storeId: id };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          that.storeInfo = response.data.data;
          if (that.storeInfo.banner) {
            // console.log(123321);
            that.ImgsList = that.storeInfo.banner.split(",");
            // this.details.Imgs = ImgsList
          } else {
            that.ImgsList = [
              "http://alycommunity.anluoyun.cn/lc-lcx/2023/6/35e14c95-10b.png",
            ];
          }
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },
    //显示预览图
    showImagePreview(index) {
      this.ImagePreviewShow = true;
      this.current = index;
    },
    onChangeImagePreview(index) {
      this.index = index;
    },
    //关闭预览图
    closeImagePreview(info) {
      this.current = info.index;
    },

    onChange(index) {
      this.count = index;
    },
    // 跳转
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/gotoJF?path=" + path,
        });
      } else {
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        this.$router.push(path);
      }
    },
    gotominiProgram(details) {
      // console.log(details);
      if (details.coordinate == "" || details.coordinate == null) {
        Toast.fail("暂无位置信息");
      } else {
        this.nameCc = {
          Navigation: "导航",
          Coordinate: details.coordinate,
        };
        if (window.__wxjs_environment === "miniprogram") {
          window.wx.miniProgram.navigateTo({
            url: "../openminip/openminip?name=" + JSON.stringify(this.nameCc),
          });
        } else {
          alert("请在小程序中打开");
        }
      }
    },
  },
};
</script>
  
  <style scoped>
@font-face {
  font-family: "Date";
  src: url(../../assets/font/DIN-MEDIUM.OTF);
}
@font-face {
  font-family: "Price";
  src: url(../../assets/font/OPPOSANS-H.TTF);
}
.essay {
  /* height: 100%; */
  width: 100%;
  margin: auto;
  padding-bottom: 65px;
  /* background: #f5f5f5; */
}
.custom-indicator {
  position: absolute;
  right: 0px;
  bottom: 46px;
  padding: 2px 15px;
  font-size: 14px;
  font-family: PingFang SC;
  color: #ffffff;
  background: #00000033;
  border-radius: 15px 0px 0px 15px;
  text-align: center;
  line-height: 20px;
}
.middle {
  width: 94%;
  margin: auto;
  /* height: 200px; */
  background: #ffffff;
  border-radius: 8px;
  position: relative;
  top: -36px;
  box-sizing: border-box;
  padding: 15px 12px;
}

.right {
  position: relative;
  /* width: 56.5%; */
  width: 100%;
  height: 76px;
  background: #f1fcfe;
  border-radius: 8px;
  background-image: url(https://dximg.dexian.ren/lczhsq/map.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  font-size: 14px;
  font-family: PingFang SC;
  /* font-weight: bold; */
  color: #1e1e1e;
  text-align: left;
  line-height: 76px;
  box-sizing: border-box;
  padding-left: 20px;
}

.box {
  padding: 25px 0px 25px 21px;
  border-top: 0.5px solid #f0f0f0;
  /* border-bottom: 0.5px solid #f0f0f0; */
}
.bed {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #1e1e1e;
  /* 超过1行 隐藏 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.address {
  margin: 10px 0;
  font-weight: 550;
  font-size: 14px;
}
.title {
  font-size: 18px;
  font-family: PingFang SC;
  /* font-weight: bold; */
  color: #1e1e1e;
}

.sanjiao {
  border-top: 4px solid #1e1e1e;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 0px solid transparent;
  display: inline-block;
  margin-left: 6px;
}
.sanjiao1 {
  border-top: 0px solid transparent;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #1e1e1e;
  display: inline-block;
  margin-left: 6px;
}

.list {
  padding-bottom: 26px;
  margin-bottom: 20px;
  width: 100%;
  margin-top: 12px;
  overflow: hidden;
}
.Box {
  column-count: 2;
  column-gap: 13px;
  column-width: auto;
  margin-top: 10px;
}

.Box::after {
  content: "";
  width: 45.5%;
  height: 0;
  visibility: hidden;
}
.li {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
  box-sizing: border-box;
  page-break-inside: avoid;
  clear: both;
  border: 1px solid #f0f0f0;
  position: relative;
}

.li img {
  border-radius: 8px 8px 0 0;
  width: 100%;
  height: auto;
  object-fit: cover;
}
.tit {
  font-size: 15px;
  font-family: PingFang SC;
  /* font-weight: bold; */
  color: #333333;
  margin-bottom: 8px;
}

.line {
  position: absolute;
  width: 100%;
  height: 1px;
  background: #ececec;
  left: 0;
}
.price {
  font-size: 14px;
  font-family: PingFang SC;
  /* font-weight: bold; */
  color: #c9261a;
  padding-top: 10px;
}

.duihuan {
  float: right;
  background: #f4bf41;
  border-radius: 12px;
  font-size: 11px;
  font-family: PingFang SC;
  /* font-weight: bold; */
  color: #333333;
  border: none;
  padding: 4px 10.5px;
  margin-top: -2px;
}
</style>